/**
 * Attaches sub-components to a component for dot-notation access (e.g. `BitkitSelect.Action`)
 * while preserving the component's type on the default export.
 *
 * `forwardRef` + a bare `Object.assign` loses the component's type info; this helper keeps it via
 * the `T & S` return type. Prefer this over `Object.assign(Component, { ... })` for compound exports.
 *
 * @example
 * export default withSubComponents(BitkitSelect, { Action: BitkitSelectMenuAction });
 */

export const withSubComponents = <T extends object, S extends Record<string, unknown>>(component: T, subs: S): T & S =>
  Object.assign(component, subs);
